// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { AdminUploadCampgroundImageData, AdminUploadCampgroundImageErrors, AdminUploadCampgroundImageResponses, CalculateDriveTimeData, CalculateDriveTimeErrors, CalculateDriveTimeResponses, CheckDisplayNameAvailabilityData, CheckDisplayNameAvailabilityErrors, CheckDisplayNameAvailabilityResponses, CreateOrUpdateProfileData, CreateOrUpdateProfileErrors, CreateOrUpdateProfileResponses, CreateReportData, CreateReportErrors, CreateReportResponses, CreateReviewData, CreateReviewErrors, CreateReviewResponses, DeleteImageData, DeleteImageErrors, DeleteImageResponses, DeleteReviewData, DeleteReviewErrors, DeleteReviewResponses, GetAdminReportsData, GetAdminReportsErrors, GetAdminReportsResponses, GetAdminStatsData, GetAdminStatsResponses, GetCampgroundDetailsData, GetCampgroundDetailsErrors, GetCampgroundDetailsResponses, GetCampgroundImagesData, GetCampgroundImagesErrors, GetCampgroundImagesForReviewData, GetCampgroundImagesForReviewErrors, GetCampgroundImagesForReviewResponses, GetCampgroundImagesResponses, GetCampgroundsData, GetCampgroundsErrors, GetCampgroundsResponses, GetCampgroundTileData, GetCampgroundTileErrors, GetCampgroundTileResponses, GetImportRunData, GetImportRunErrors, GetImportRunResponses, GetImportRunsData, GetImportRunsErrors, GetImportRunsResponses, GetMyProfileData, GetMyProfileResponses, GetMyReviewData, GetMyReviewErrors, GetMyReviewResponses, GetPendingImagesData, GetPendingImagesErrors, GetPendingImagesResponses, GetReportsData, GetReportsErrors, GetReportsResponses, GetReviewsData, GetReviewsErrors, GetReviewsResponses, GetSearchResultData, GetSearchResultErrors, GetSearchResultResponses, HealthCheckHealthGetData, HealthCheckHealthGetResponses, ReorderCampgroundImagesData, ReorderCampgroundImagesErrors, ReorderCampgroundImagesResponses, SearchCampgroundsByDriveTimeData, SearchCampgroundsByDriveTimeErrors, SearchCampgroundsByDriveTimeResponses, SearchCampgroundsByRectangleData, SearchCampgroundsByRectangleErrors, SearchCampgroundsByRectangleResponses, StreamSearchProgressData, StreamSearchProgressErrors, StreamSearchProgressResponses, UpdateImageApprovalData, UpdateImageApprovalErrors, UpdateImageApprovalResponses, UpdateImageTagsData, UpdateImageTagsErrors, UpdateImageTagsResponses, UpdateReportStatusData, UpdateReportStatusErrors, UpdateReportStatusResponses, UpdateReviewData, UpdateReviewErrors, UpdateReviewResponses, UploadCampgroundImageData, UploadCampgroundImageErrors, UploadCampgroundImageResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Search By Rectangular Region
 *
 * Search campgrounds within a rectangular region defined by 4 lat/lng pairs.
 */
export const searchCampgroundsByRectangle = <ThrowOnError extends boolean = false>(options: Options<SearchCampgroundsByRectangleData, ThrowOnError>) => (options.client ?? client).post<SearchCampgroundsByRectangleResponses, SearchCampgroundsByRectangleErrors, ThrowOnError>({
    url: '/api/search/campgrounds/by-rectangle',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Campgrounds In A Map Tile
 *
 * Campgrounds inside one Web Mercator tile. Cacheable: the client requests the tiles covering its viewport and unions them.
 */
export const getCampgroundTile = <ThrowOnError extends boolean = false>(options: Options<GetCampgroundTileData, ThrowOnError>) => (options.client ?? client).get<GetCampgroundTileResponses, GetCampgroundTileErrors, ThrowOnError>({ url: '/api/search/campgrounds/tile/{z}/{x}/{y}', ...options });

/**
 * Search By Drive Time
 *
 * Enqueue a search job for campgrounds within a drive time radius. Returns job ID for progress tracking.
 */
export const searchCampgroundsByDriveTime = <ThrowOnError extends boolean = false>(options: Options<SearchCampgroundsByDriveTimeData, ThrowOnError>) => (options.client ?? client).post<SearchCampgroundsByDriveTimeResponses, SearchCampgroundsByDriveTimeErrors, ThrowOnError>({
    url: '/api/search/campgrounds/by-drive-time',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Search Result
 *
 * Retrieve the result of a completed search job.
 */
export const getSearchResult = <ThrowOnError extends boolean = false>(options: Options<GetSearchResultData, ThrowOnError>) => (options.client ?? client).get<GetSearchResultResponses, GetSearchResultErrors, ThrowOnError>({ url: '/api/search/campgrounds/result/{job_id}', ...options });

/**
 * Calculate Drive Time
 *
 * Calculate drive time between two locations.
 */
export const calculateDriveTime = <ThrowOnError extends boolean = false>(options: Options<CalculateDriveTimeData, ThrowOnError>) => (options.client ?? client).post<CalculateDriveTimeResponses, CalculateDriveTimeErrors, ThrowOnError>({
    url: '/api/search/directions/drive-time',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stream Search Progress
 *
 * Server-Sent Events stream for real-time search progress updates.
 */
export const streamSearchProgress = <ThrowOnError extends boolean = false>(options: Options<StreamSearchProgressData, ThrowOnError>) => (options.client ?? client).get<StreamSearchProgressResponses, StreamSearchProgressErrors, ThrowOnError>({ url: '/api/search/progress/{job_id}', ...options });

/**
 * Health Check
 */
export const healthCheckHealthGet = <ThrowOnError extends boolean = false>(options?: Options<HealthCheckHealthGetData, ThrowOnError>) => (options?.client ?? client).get<HealthCheckHealthGetResponses, unknown, ThrowOnError>({ url: '/health', ...options });

/**
 * Get Campground Details
 */
export const getCampgroundDetails = <ThrowOnError extends boolean = false>(options: Options<GetCampgroundDetailsData, ThrowOnError>) => (options.client ?? client).get<GetCampgroundDetailsResponses, GetCampgroundDetailsErrors, ThrowOnError>({ url: '/api/campgrounds/{campground_sqid}', ...options });

/**
 * Get Campground Images
 *
 * Retrieve images for a specific campground.
 */
export const getCampgroundImages = <ThrowOnError extends boolean = false>(options: Options<GetCampgroundImagesData, ThrowOnError>) => (options.client ?? client).get<GetCampgroundImagesResponses, GetCampgroundImagesErrors, ThrowOnError>({ url: '/api/campgrounds/{campground_sqid}/images', ...options });

/**
 * Upload Campground Image
 *
 * Upload an image for a campground (requires authentication). Image will be pending admin approval.
 */
export const uploadCampgroundImage = <ThrowOnError extends boolean = false>(options: Options<UploadCampgroundImageData, ThrowOnError>) => (options.client ?? client).post<UploadCampgroundImageResponses, UploadCampgroundImageErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/campgrounds/{campground_sqid}/images',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get reviews
 *
 * Get paginated reviews for a campground.
 */
export const getReviews = <ThrowOnError extends boolean = false>(options: Options<GetReviewsData, ThrowOnError>) => (options.client ?? client).get<GetReviewsResponses, GetReviewsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/campgrounds/{campground_sqid}/reviews',
    ...options
});

/**
 * Create a review
 *
 * Create a new review for a campground. Users can only have one review per campground.
 */
export const createReview = <ThrowOnError extends boolean = false>(options: Options<CreateReviewData, ThrowOnError>) => (options.client ?? client).post<CreateReviewResponses, CreateReviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/campgrounds/{campground_sqid}/reviews',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get my review
 *
 * Get the current user's review for a campground.
 */
export const getMyReview = <ThrowOnError extends boolean = false>(options: Options<GetMyReviewData, ThrowOnError>) => (options.client ?? client).get<GetMyReviewResponses, GetMyReviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/campgrounds/{campground_sqid}/reviews/me',
    ...options
});

/**
 * Delete a review
 *
 * Delete a review. Users can only delete their own reviews.
 */
export const deleteReview = <ThrowOnError extends boolean = false>(options: Options<DeleteReviewData, ThrowOnError>) => (options.client ?? client).delete<DeleteReviewResponses, DeleteReviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/campgrounds/{campground_sqid}/reviews/{review_id}',
    ...options
});

/**
 * Update a review
 *
 * Update an existing review. Users can only update their own reviews.
 */
export const updateReview = <ThrowOnError extends boolean = false>(options: Options<UpdateReviewData, ThrowOnError>) => (options.client ?? client).put<UpdateReviewResponses, UpdateReviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/campgrounds/{campground_sqid}/reviews/{review_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get reports (admin only)
 *
 * Get paginated reports for a campground. Admin access required.
 */
export const getReports = <ThrowOnError extends boolean = false>(options: Options<GetReportsData, ThrowOnError>) => (options.client ?? client).get<GetReportsResponses, GetReportsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/campgrounds/{campground_sqid}/reports',
    ...options
});

/**
 * Create a report
 *
 * Create a new issue report for a campground.
 */
export const createReport = <ThrowOnError extends boolean = false>(options: Options<CreateReportData, ThrowOnError>) => (options.client ?? client).post<CreateReportResponses, CreateReportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/campgrounds/{campground_sqid}/reports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get admin dashboard statistics
 *
 * Get counts of pending items and totals for admin dashboard.
 */
export const getAdminStats = <ThrowOnError extends boolean = false>(options?: Options<GetAdminStatsData, ThrowOnError>) => (options?.client ?? client).get<GetAdminStatsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/stats',
    ...options
});

/**
 * Get all campgrounds with image counts
 *
 * Get a paginated list of all campgrounds with image statistics.
 */
export const getCampgrounds = <ThrowOnError extends boolean = false>(options?: Options<GetCampgroundsData, ThrowOnError>) => (options?.client ?? client).get<GetCampgroundsResponses, GetCampgroundsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/campgrounds',
    ...options
});

/**
 * Get pending image approvals grouped by campground
 *
 * Get campgrounds with pending images, grouped for easier review.
 */
export const getPendingImages = <ThrowOnError extends boolean = false>(options?: Options<GetPendingImagesData, ThrowOnError>) => (options?.client ?? client).get<GetPendingImagesResponses, GetPendingImagesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/images/pending',
    ...options
});

/**
 * Get campground images for admin review
 *
 * Get all pending and approved images for a campground to facilitate duplicate detection.
 */
export const getCampgroundImagesForReview = <ThrowOnError extends boolean = false>(options: Options<GetCampgroundImagesForReviewData, ThrowOnError>) => (options.client ?? client).get<GetCampgroundImagesForReviewResponses, GetCampgroundImagesForReviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/campgrounds/{campground_sqid}/images/review',
    ...options
});

/**
 * Delete an image
 *
 * Delete an image from both Cloudflare and the database.
 */
export const deleteImage = <ThrowOnError extends boolean = false>(options: Options<DeleteImageData, ThrowOnError>) => (options.client ?? client).delete<DeleteImageResponses, DeleteImageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/images/{image_id}',
    ...options
});

/**
 * Approve or reject an image
 *
 * Update image approval status.
 */
export const updateImageApproval = <ThrowOnError extends boolean = false>(options: Options<UpdateImageApprovalData, ThrowOnError>) => (options.client ?? client).patch<UpdateImageApprovalResponses, UpdateImageApprovalErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/images/{image_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reorder campground images
 *
 * Reorder approved images for a campground. First image becomes the hero image.
 */
export const reorderCampgroundImages = <ThrowOnError extends boolean = false>(options: Options<ReorderCampgroundImagesData, ThrowOnError>) => (options.client ?? client).put<ReorderCampgroundImagesResponses, ReorderCampgroundImagesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/campgrounds/{campground_sqid}/images/order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update image tags
 *
 * Update amenity tags and description for an image.
 */
export const updateImageTags = <ThrowOnError extends boolean = false>(options: Options<UpdateImageTagsData, ThrowOnError>) => (options.client ?? client).patch<UpdateImageTagsResponses, UpdateImageTagsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/images/{image_id}/tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload Campground Image (Admin)
 *
 * Upload an image for a campground as an admin. Image is automatically approved.
 */
export const adminUploadCampgroundImage = <ThrowOnError extends boolean = false>(options: Options<AdminUploadCampgroundImageData, ThrowOnError>) => (options.client ?? client).post<AdminUploadCampgroundImageResponses, AdminUploadCampgroundImageErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/campgrounds/{campground_sqid}/images',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get all reports (admin)
 *
 * Get paginated list of all reports with optional status filter.
 */
export const getAdminReports = <ThrowOnError extends boolean = false>(options?: Options<GetAdminReportsData, ThrowOnError>) => (options?.client ?? client).get<GetAdminReportsResponses, GetAdminReportsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/reports',
    ...options
});

/**
 * Update report status
 *
 * Update a report's status and optionally add admin notes.
 */
export const updateReportStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateReportStatusData, ThrowOnError>) => (options.client ?? client).patch<UpdateReportStatusResponses, UpdateReportStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/reports/{report_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get recent OSM import runs
 *
 * Get the most recent import runs and their churn counts, newest first.
 */
export const getImportRuns = <ThrowOnError extends boolean = false>(options?: Options<GetImportRunsData, ThrowOnError>) => (options?.client ?? client).get<GetImportRunsResponses, GetImportRunsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/import-runs',
    ...options
});

/**
 * Get one import run with its change rows
 *
 * Get an import run's counts plus the campgrounds it added and removed.
 */
export const getImportRun = <ThrowOnError extends boolean = false>(options: Options<GetImportRunData, ThrowOnError>) => (options.client ?? client).get<GetImportRunResponses, GetImportRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/import-runs/{run_id}',
    ...options
});

/**
 * Create or update user profile
 *
 * Set or update the display name for the current user.
 */
export const createOrUpdateProfile = <ThrowOnError extends boolean = false>(options: Options<CreateOrUpdateProfileData, ThrowOnError>) => (options.client ?? client).put<CreateOrUpdateProfileResponses, CreateOrUpdateProfileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get my profile
 *
 * Get the current user's profile.
 */
export const getMyProfile = <ThrowOnError extends boolean = false>(options?: Options<GetMyProfileData, ThrowOnError>) => (options?.client ?? client).get<GetMyProfileResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/profile/me',
    ...options
});

/**
 * Check display name availability
 *
 * Check if a display name is available (case-insensitive). Requires authentication.
 */
export const checkDisplayNameAvailability = <ThrowOnError extends boolean = false>(options: Options<CheckDisplayNameAvailabilityData, ThrowOnError>) => (options.client ?? client).get<CheckDisplayNameAvailabilityResponses, CheckDisplayNameAvailabilityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/profile/check/{display_name}',
    ...options
});
